import { Popover, styled } from '@mui/material';
import { forwardRef } from 'react';

const CustomPopover = styled(Popover)(({ theme }) => {
    return {
        '& .MuiBackdrop-root': {
            background: 'transparent',
        },
        '& .MuiPaper-root': {
            padding: theme.spacing(2),
            boxShadow: theme.palette.ensightful.shadows[1],
        },
    };
});

export default forwardRef((props, ref) => {
    return <CustomPopover ref={ref} {...props} />;
});
